export default "__VITE_ASSET__C$s8sYi8__"